import { EncryptAES, DecryptAES } from "./crypto";
import store from "../store";

const ulsname = "_cmauls";
const utkn = "_cmautk";
const sessckname = "_cmsess";
const sessexp = "30d";
const lngckname = "_realn";
const defaultlng = "AZ";

function SetUser(user) {
  if (!user) {
    localStorage.removeItem(ulsname);
  } else {
    let tk = LoadCookie(utkn);
    if (tk) {
      localStorage.setItem(ulsname, EncryptAES(JSON.stringify(user), tk));
    }
    store.state.user = user;
  }
  return;
}

function LoadUser() {
  if (localStorage.getItem(ulsname) !== null) {
    try {
      let tk = LoadCookie(utkn);
      let u = JSON.parse(DecryptAES(localStorage.getItem(ulsname), tk));
      
      return u;
    } catch (err) {
      return err;
    }
  }
}

function SetUserToken(tkn) {
  SetCookie(utkn, tkn);
  return;
}

function SetCookie(name, value, exp) {
  if (exp === undefined) exp = sessexp;
  let cookieOptions = {
    expires: exp,
    path: '/', 
    secure: true, 
    sameSite: 'Strict' 
  };
  $cookies.set(name, value, cookieOptions);
}

function SetSession(tkn) {
  SetCookie(sessckname, tkn, "Session"); 
}


function GetSession() {
  return $cookies.get(sessckname);
}

function RemoveSession() {
  $cookies.remove(sessckname);
}

function LoadCookie(name) {
  if (!$cookies) return;
  if ($cookies.isKey(name)) return $cookies.get(name);
}

function SaveStatePlugin(store) {

  store.subscribe((mutation, state) => {
    SetUser(state.user);
    SetLang(state.lang);
  });
}

function AuthUser(user, utk, stk) {
  SetUserToken(utk);
  SetUser(user);
  SetSession(stk);
}

function SetLang(lang) {
  SetCookie(lngckname, lang);
}

function LoadLang(lang) {
  var l = LoadCookie(lngckname);
  if (l) return l;
  else return defaultlng;
}


export {
  LoadLang,
  SetUser,
  LoadUser,
  SaveStatePlugin,
  GetSession,
  RemoveSession,
  AuthUser,
  SetCookie,
  LoadCookie,
  ulsname
};
